import { AdobeLaunchState as adobeLaunchState } from '@interfaces/state';
import { Action, createReducer, on } from '@ngrx/store';
import { TrackProcessStart } from '@store/actions';

export interface AdobeLaunchState extends adobeLaunchState {}
export const initialState: AdobeLaunchState = {
  TrackProcessStartCalled: false,
};

const adobeLaunchReducer = createReducer(
  initialState,
  on(TrackProcessStart, (state) => ({
    ...state,
    TrackProcessStartCalled: true,
  })),
);

export function reducer(state: AdobeLaunchState | undefined, action: Action) {
  return adobeLaunchReducer(state, action);
}

export const getTrackProcessStartCalled = (state: AdobeLaunchState) =>
  state.TrackProcessStartCalled;
